import createAndEnterEngagement from './createAndEnterEngagement';

export default function loadNextEngagement() {
	return (dispatch, getState) => {
		dispatch(createAndEnterEngagement());
	}
}


// WEBPACK FOOTER //
// ./src/actions/loadNextEngagement.js